import React from 'react'

import { useTranslation } from 'react-i18next'

const NoResults: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center justify-start mt-4 px-4">
      <h1 className="font-medium text-xl text-black dark:text-gray mb-1 mt-2">
        {t('messages.noResults')}
      </h1>
      <p className="font-base text-gray-text dark:text-gray text-md">{t('messages.checkSearch')}</p>
    </div>
  )
}

export default NoResults
